import React from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';

import Root from './modules/root/main';
import NotFound from './modules/not-found/main';
import AdminList from './modules/admins/list';
import AdminCreate from './modules/admins/create';
import AdminEdit from './modules/admins/edit';
import ShowcaseMain from './modules/showcase/main';
import StatInvalidMain from './modules/statistics/invalid/main';
import StatGeneralMain from './modules/statistics/general/main';
import StatConversionsMain from './modules/statistics/conversions/main';
import StatUnacceptableConversionsMain from './modules/statistics/unacceptable-conversions/main';
import StatUnacceptableConversionsStatMain from './modules/statistics/unacceptable-conversions-stat/main';
import CampaignDomainsList from './modules/campaign-domains/list';
import CampaignDomainsCreate from './modules/campaign-domains/create';
import CampaignDomainsEdit from './modules/campaign-domains/edit';
import ProgramsList from './modules/programs/list/main';
import ProgramsAdditionalList from './modules/programs/additional-list/main';
import LocationsPlan from './modules/programs/locations-plan/main';
import ProgramsEditor from './modules/programs/editor/main';
import ProgramsInfo from './modules/programs/info/main';
import ProgramsCategoryList from './modules/programs/category/list/main';
import ProgramsCategoryEditor from './modules/programs/category/editor/main';
import ThreadsList from './modules/threads/list/main';
import ThreadsItem from './modules/threads/item/main';
import AffiliatesList from './modules/affiliates/list/main';
import AffiliateEdit from './modules/affiliates/edit/main';
import NewsList from './modules/news/list/main';
import NewsEdit from './modules/news/edit/main';
import DiscountsList from './modules/discounts/list/main';
import TopOffersList from './modules/top-offers/main';
import TopAffiliatesList from './modules/top-affiliates/main';
import TopCountriesList from './modules/top-countries/main';
import DiscountsEdit from './modules/discounts/edit/main';
import OfferLangRulesList from './modules/offer-location-rules/lang-rules/list/main';
import OfferLangRulesEdit from './modules/offer-location-rules/lang-rules/edit/main';
import OfferGeoRulesList from './modules/offer-location-rules/geo-rules/list/main';
import OfferGeoRulesEdit from './modules/offer-location-rules/geo-rules/edit/main';
import PayoutSystemsList from './modules/payout-systems/list';
import PayoutSystemsCreate from './modules/payout-systems/create';
import PayoutSystemsEdit from './modules/payout-systems/edit';
import PayoutsList from './modules/payouts/list/main';
import PayoutsRequestsList from './modules/payout-requests/list-request/main';
import RequestHistoryList from './modules/payout-requests/request-history/main';
import PayoutsRequestsRegister from './modules/payout-requests/list-register/main';
import PayoutsRequestsTrafficScaling from './modules/payout-requests/list-traffic-scaling/main';
import PayoutsRequestsStat from './modules/payout-requests/list-stat/main';
import RiskPayouts from './modules/payout-requests/risk-payouts/main';
import PayoutMatrix from './modules/payout-requests/payout-matrix/main';
import LandingSnippetsList from './modules/landing-snippets/list';
import LandingSnippetsCreate from './modules/landing-snippets/create';
import LandingSnippetsEdit from './modules/landing-snippets/edit';
import AffiliatesActivityList from './modules/affiliates-activity/main';
import ManagersAffiliatesActivity from './modules/managers-affiliates-activity/main';
import RegistrationAnalytics from './modules/registration-analytics/main';
import MarketingFunnel from './modules/marketing-funnel/main/main';
import RegistrationActivity from './modules/marketing-funnel/registration-activity/main';
import MarketingFunnelActivity from './modules/marketing-funnel/activity/main';
import MarketingFunnelAffilaiteStat from './modules/marketing-funnel/affiliate-stat/main';
import ProductCap from './modules/product-cap/main';
import Priorities from './modules/priorities/main';
import WeeklyReport from './modules/weekly-report/main';
import QuidsReport from './modules/quids-report/main';
import DailyApprovesList from './modules/daily-approves-list/main';
import AffiliateProfile from './modules/affiliates/profile/main';
import ManualMailingsList from './modules/mailings-new/manual-mailings/list/main';
import ManualMailingsEditor from './modules/mailings-new/manual-mailings/editor/main';
import TriggeredMailingsList from './modules/mailings-new/triggered-mailings/list/main';
import TriggeredMailingsEditor from './modules/mailings-new/triggered-mailings/editor/main';
import MailingsImageList from './modules/mailings-new/image/list/main';
import MailingsImageEditor from './modules/mailings-new/image/editor/main';
import AdminProfile from './modules/admins/profile/main';
import DefinedReferersList from './modules/defined-referers/main';
import ExternalThreadsList from './modules/external-threads/list/main';
import ExternalThreadsItem from './modules/external-threads/item/main';
import CampaignsList from './modules/campaigns/main';
import CampaignsPayoutEditor from './modules/campaigns/payout-editor/main';
import PollsList from './modules/polls/main';
import WM from './modules/wm/main';
import AdvRequests from './modules/advertisers-requests/list/main';
import AffiliatesRedeem from './modules/affiliates-redeem/main';
import AffiliateManagersProductivity from './modules/affiliate-managers-productivity/main';
import trafficAccounting from './modules/traffic-accounting/main';
import AlertsAnalytics from './modules/alerts-analytics/main';
import ConversionsApprove from './modules/conversions-approve/main';
import ConversionsApproveRequests from './modules/conversions-approve-requests/main';
import ConversionsGarantApproveRequests from './modules/conversions-garant-approve-requests/main';
import GuarantApproveRequests from './modules/guarant-approve-register/list/main';
import GuarantApproveRequestsEditor from './modules/guarant-approve-register/editor/main';

import LimitedGarants from './modules/limited-garants/list/main';
import LimitedGarantsEditor from './modules/limited-garants/editor/main';

import LimitedGarantsAnalysis from './modules/limited-garants-analysis/list/main';
import GarantForecast from './modules/garant-forecast/main';
import FinReports from './modules/fin-reports/main';
import LandingReports from './modules/landing-reports/main';
import AffiliateReports from './modules/affiliate-reports/main';
import PromoReports from './modules/promo-reports/main';
import PayoutLogTransfers from './modules/payout-log/transfers/main';
import PayoutLogPayments from './modules/payout-log/payments/main';
import GoodsList from './modules/goods/list/main';
import GoodsEditor from './modules/goods/editor/main';
import GoodsCategoryList from './modules/goods/category/list/main';
import GoodsCategoryEditor from './modules/goods/category/editor/main';
import MissionsList from './modules/missions/list/main';
import MissionsEditor from './modules/missions/editor/main';
import AchievementList from './modules/missions/achievement/list/main';
import AchievementEditor from './modules/missions/achievement/editor/main';
import MarketingReport from './modules/marketing-reports/main';
import ExchangeRates from './modules/exchange-rates/main';
import RanksAndPointsReport from './modules/ranks-points-report/main';
import BmAccounts from './modules/bm-accounts/list/main';
import BmAccountsEditor from './modules/bm-accounts/editor/main';
import BmCategories from './modules/bm-accounts/category/list/main';
import BmCategoriesEditor from './modules/bm-accounts/category/editor/main';
import ContestsList from './modules/contests/list';
import ContestsEditor from './modules/contests/edit';
import PromoCodesList from './modules/promo-codes/list';
import MonthlyCashbackList from './modules/promo-codes/list-monthly-cashback';

import BannersPublicationList from './modules/banners/publication/list/main';
import BannersPublicationEditor from './modules/banners/publication/editor/main';
import BannersContentList from './modules/banners/content/list/main';
import BannersContentEditor from './modules/banners/content/editor/main';
import BannersCustomContentList from './modules/banners/custom-content/list/main';
import BannersImageList from './modules/banners/image/list/main';
import BannersImageEditor from './modules/banners/image/editor/main';
import BannersCampaignList from './modules/banners/campaign/list/main';
import BannersManual from './modules/banners/manual/main';
import PopupsPopupList from './modules/popups/popup/list/main';
import PopupsPopupEditor from './modules/popups/popup/editor/main';
import PopupsImageList from './modules/popups/image/list/main';
import PopupsImageEditor from './modules/popups/image/editor/main';
import PopupsCampaignList from './modules/popups/campaigns/list/main';
import PopupsCustomContentList from './modules/popups/custom-content/list/main';

import BlogArticleList from './modules/blog/article/list/main';
import BlogArticleEditor from './modules/blog/article/editor/main';
import BlogArticleImageList from './modules/blog/article-image/list/main';
import BlogArticleImageEditor from './modules/blog/article-image/editor/main';
import BlogArticleTagList from './modules/blog/article-tag/list/main';
import BlogArticleTagEditor from './modules/blog/article-tag/editor/main';
import BlogArticleCommentList from './modules/blog/article-comment/list/main';
import BlogArticleCommentEditor from './modules/blog/article-comment/editor/main';

import PostbackLog from './modules/postback-log/main';

const isRocket = process.env.CPA_ENV === 'rocket';

import CplRulesList from './modules/cpl-rules/list';
import CplRulesEditor from './modules/cpl-rules/edit';

import ApproveRejectList from './modules/approve-reject/list';
import ApproveRejectEditor from './modules/approve-reject/edit';

import geoPayoutRatesList from './modules/geo-payout-rates/list';
import geoPayoutRatesEditor from './modules/geo-payout-rates/edit';

export default (
	<Route component={Root} path="/">
		<Route path="admins">
			<IndexRoute component={AdminList} />
			<Route path="create" component={AdminCreate} />
			<Route path="edit/:id" component={AdminEdit} />
		</Route>
		<Route path="profile" component={AdminProfile} />
		<Route path="statistics">
			<Route path="general" component={StatGeneralMain} />
			<Route path="invalid" component={StatInvalidMain} />
			<Route path="conversions" component={StatConversionsMain} />
			<Route path="unacceptable-conversions" component={StatUnacceptableConversionsMain} />
			<Route path="unacceptable-stat" component={StatUnacceptableConversionsStatMain} />
			<IndexRedirect to="general" />
		</Route>
		<Route path="showcase"  component={ShowcaseMain}/>
		<Route path="campaign-domains">
			<IndexRoute component={CampaignDomainsList} />
			<Route path="create" component={CampaignDomainsCreate} />
			<Route path="edit/:id" component={CampaignDomainsEdit} />
		</Route>
		<Route path="programs">
			<Route path="list" component={ProgramsList} />
			<Route path="stopped-list" component={ProgramsList} isStoppedList={true} />
			<Route path="additional-list" component={ProgramsAdditionalList} />
			<Route path="locations-plan" component={LocationsPlan} />
			<Route path="editor(/:id)" component={ProgramsEditor} />
			<Route path="info(/:id)" component={ProgramsInfo} />
			<Route path="categories" component={ProgramsCategoryList} />
			<Route path="categories(/:id)/editor" component={ProgramsCategoryEditor} />
			<IndexRedirect to="list" />
		</Route>
		<Route path="threads">
			<IndexRoute component={ThreadsList} />
			<Route path=":id" component={ThreadsItem} />
		</Route>
		<Route path="external-tickets">
			<IndexRoute
				component={ExternalThreadsList}
			/>
			<Route
				path=":id"
				component={ExternalThreadsItem}
			/>
		</Route>
		<Route path="affiliates">
			<IndexRoute component={AffiliatesList} />
			<Route path="edit/:id" component={AffiliateEdit} />
			<Route path="profile/:id" component={AffiliateProfile} />
		</Route>
		<Route path="news">
			<IndexRoute component={NewsList} />
			<Route path="edit(/:id)" component={NewsEdit} />
		</Route>
		<Route path="discounts">
			<IndexRoute component={DiscountsList} />
			<Route path="edit(/:id)" component={DiscountsEdit} />
			<Route path="new" component={DiscountsEdit} />
		</Route>
		<Route path="top-offers">
			<IndexRoute component={TopOffersList} />
		</Route>
		<Route path="top-affiliates">
			<IndexRoute component={TopAffiliatesList} />
		</Route>
		<Route path="top-countries">
			<IndexRoute component={TopCountriesList} />
		</Route>
		<Route path="offer-location-rules">
			<Route path="lang-rules" component={OfferLangRulesList} />
			<Route path="lang-rules/edit(/:lang)" component={OfferLangRulesEdit} />
			<Route path="lang-rules/new" component={OfferLangRulesEdit} />

			<Route path="geo-rules" component={OfferGeoRulesList} />
			<Route path="geo-rules/edit(/:code)" component={OfferGeoRulesEdit} />
			<Route path="geo-rules/new" component={OfferGeoRulesEdit} />

			<IndexRedirect to="geo-rules" />
		</Route>
		<Route path="goods">
			<Route path="list" component={GoodsList} />
			<Route path="edit(/:id)" component={GoodsEditor} />
			<Route path="categories" component={GoodsCategoryList} />
			<Route path="categories(/:id)/editor" component={GoodsCategoryEditor} />
			<IndexRedirect to="list" />
		</Route>
		<Route path="missions">
			<Route path="list" component={MissionsList} />
			<Route path="edit(/:id)" component={MissionsEditor} />
			<IndexRedirect to="list" />
		</Route>
		<Route path="achievements">
			<Route path="list" component={AchievementList} />
			<Route path="edit(/:id)" component={AchievementEditor} />
			<IndexRedirect to="list" />
		</Route>
		<Route path="payout-systems">
			<IndexRoute component={PayoutSystemsList} />
			<Route path="create" component={PayoutSystemsCreate} />
			<Route path="edit/:id" component={PayoutSystemsEdit} />
		</Route>
		<Route path="payouts">
			<IndexRoute component={PayoutsList} />
		</Route>
		<Route path="payout-requests">
			<IndexRoute component={PayoutsRequestsList} />
			<Route path="payout-matrix" component={PayoutMatrix}/>
		</Route>
		<Route path="payout-reqs-lists">
			<IndexRedirect to="payout-matrix" />
			<Route path="payout-matrix" component={PayoutMatrix}/>
		</Route>
		<Route path="request-history">
			<IndexRoute component={RequestHistoryList} />
		</Route>
		<Route path="payout-register-requests">
			<IndexRoute component={PayoutsRequestsRegister} />
		</Route>
		<Route path="payout-reqs-lists/payout-scaling">
			<IndexRoute component={PayoutsRequestsTrafficScaling} />
		</Route>
		<Route path="stat-pay-requests">
			<IndexRoute component={PayoutsRequestsStat} />
		</Route>
		<Route path="risk-payouts">
			<IndexRoute component={RiskPayouts} />
		</Route>
		<Route path="landing-snippets">
			<IndexRoute component={LandingSnippetsList} />
			<Route path="create" component={LandingSnippetsCreate} />
			<Route path="edit/:id" component={LandingSnippetsEdit} />
		</Route>
		<Route path="bm-accounts">
			<IndexRedirect to="list" />
			<Route path="list" component={BmAccounts} />
			<Route path="edit(/:id)" component={BmAccountsEditor} />
			<Route path="categories" component={BmCategories} />
			<Route path="categories/edit(/:id)" component={BmCategoriesEditor} />
		</Route>
		<Route path="affiliates-activity">
			<IndexRoute component={AffiliatesActivityList} />
		</Route>
		<Route path="managers-affiliates-activity" component={ManagersAffiliatesActivity} />
		<Route path="registration-analytics" component={RegistrationAnalytics} />
		<Route path="marketing-funnel">
			<Route path="main" component={isRocket ? MarketingFunnel : RegistrationActivity} />
			{
				!isRocket &&
				<Route path="old" component={MarketingFunnel} />
			}
			<Route path="activity" component={MarketingFunnelActivity} />
			<Route path="affiliate-stat" component={MarketingFunnelAffilaiteStat} />
			<IndexRedirect to="main" />
		</Route>
		<Route path="product-cap" component={ProductCap} />
		<Route path="priorities" component={Priorities} />
		<Route path="weekly-report" component={WeeklyReport} />
		<Route path="quids-report" component={QuidsReport} />
		<Route path="daily-approves-list" component={DailyApprovesList} />
		<Route path="mailings-new">
			<Route path="manual-mailings" component={ManualMailingsList} />
			<Route path="manual-mailings(/:id)/editor" component={ManualMailingsEditor} />
			<Route path="triggered-mailings" component={TriggeredMailingsList} />
			<Route path="triggered-mailings(/:id)/editor" component={TriggeredMailingsEditor} />
			<Route path="images" component={MailingsImageList} />
			<Route path="images(/:id)/editor" component={MailingsImageEditor} />
			<IndexRedirect to="manual-mailings" />
		</Route>
		<Route path="defined-referers" component={DefinedReferersList} />
		<Route path="campaigns" component={CampaignsList} />
		<Route path="campaigns/:id/payout-editor" component={CampaignsPayoutEditor} />
		<Route path="postback-log" component={PostbackLog} />
		<Route path="polls" component={PollsList} />
		<Route path="wm" component={WM} />
		<Route path="adv-requests" component={AdvRequests} />
		<Route path="affiliates-redeem" component={AffiliatesRedeem} />
		<Route path="traffic-accounting" component={trafficAccounting} />
		<Route path="alerts-analytics" component={AlertsAnalytics} />
		<Route path="conversions-approve" component={ConversionsApprove} />
		<Route path="conversions-approve-requests" component={ConversionsApproveRequests} />
		<Route path="conversions-garant-approve-requests" component={ConversionsGarantApproveRequests} />
		<Route path="limited-garants">
			<IndexRoute component={LimitedGarants} />
			<Route path="create" component={LimitedGarantsEditor} />
			<Route path="edit(/:id)" component={LimitedGarantsEditor} />
		</Route>
		<Route path="analysis-lim-garants">
			<IndexRoute component={LimitedGarantsAnalysis} />
		</Route>
		<Route path="guarant-approve-requests">
			<IndexRoute component={GuarantApproveRequests} />
			<Route path="create" component={GuarantApproveRequestsEditor} />
			<Route path="edit(/:id)" component={GuarantApproveRequestsEditor} />
		</Route>
		<Route path="garant-forecast">
			<IndexRoute component={GarantForecast} />
		</Route>
		<Route path="affiliates-redeem">
			<IndexRoute component={AffiliatesRedeem} />
		</Route>
		<Route path="affiliate-managers-productivity">
			<Route path="teams" component={AffiliateManagersProductivity} />
			<Route path="individual" component={AffiliateManagersProductivity} />
			<Route path="motivation" component={AffiliateManagersProductivity} />
			<IndexRedirect to="teams" />
		</Route>
		<Route path="fin-reports" component={FinReports} />
		<Route path="landing-reports" component={LandingReports} />
		<Route path="affiliate-reports" component={AffiliateReports} />
		<Route path="promo-reports" component={PromoReports} />
		<Route path="marketing-reports" component={MarketingReport} />
		<Route path="exchange-rates" component={ExchangeRates} />
		{isRocket && (
			<Route path="ranks-points-report" component={RanksAndPointsReport} />
		)}
		<Route path="payout-log">
			<Route path="transfers" component={PayoutLogTransfers} />
			<Route path="payments" component={PayoutLogPayments} />
			<IndexRedirect to="transfers" />
		</Route>
		<Route path="banners">
			<Route path="publications" component={BannersPublicationList} />
			<Route path="publications(/:id)/editor" component={BannersPublicationEditor} />
			<Route path="contents" component={BannersContentList} />
			<Route path="contents(/:id)/editor" component={BannersContentEditor} />
			<Route path="custom-content" component={BannersCustomContentList} />
			<Route path="images" component={BannersImageList} />
			<Route path="images(/:id)/editor" component={BannersImageEditor} />
			<Route path="campaigns" component={BannersCampaignList} />
			<Route path="manual" component={BannersManual} />
			<IndexRedirect to="publications" />
		</Route>
		<Route path="cpl-rules">
			<IndexRoute component={CplRulesList} />
			<Route path="create" component={CplRulesEditor} />
			<Route path="edit(/:id)" component={CplRulesEditor} />
		</Route>
		<Route path="contests">
			<IndexRoute component={ContestsList} />
			<Route path="create" component={ContestsEditor} />
			<Route path="edit(/:id)" component={ContestsEditor} />
		</Route>
		<Route path="promo-codes">
			<IndexRoute component={PromoCodesList} />
		</Route>
		<Route path="monthly-cashback">
			<IndexRoute component={MonthlyCashbackList} />
		</Route>
		<Route path="approve-reject">
			<IndexRoute component={ApproveRejectList} />
			<Route path="create" component={ApproveRejectEditor} />
			<Route path="edit" component={ApproveRejectEditor} />
		</Route>
		<Route path="geo-payout-rates">
			<IndexRoute component={geoPayoutRatesList} />
			<Route path="create" component={geoPayoutRatesEditor} />
			<Route path="edit" component={geoPayoutRatesEditor} />
		</Route>
		{isRocket && (
			<Route path="popups">
				<Route path="main" component={PopupsPopupList} />
				<Route path="main(/:id)/editor" component={PopupsPopupEditor} />
				<Route path="images" component={PopupsImageList} />
				<Route path="images(/:id)/editor" component={PopupsImageEditor} />
				<Route path="campaigns" component={PopupsCampaignList} />
				<Route path="custom-content" component={PopupsCustomContentList} />
				<IndexRedirect to="main" />
			</Route>
		)}
		{isRocket && (
			<Route path="blog">
				<Route path="articles" component={BlogArticleList} />
				<Route path="articles(/:id)/editor" component={BlogArticleEditor} />
				<Route path="article-images" component={BlogArticleImageList} />
				<Route path="article-images(/:id)/editor" component={BlogArticleImageEditor} />
				<Route path="article-tags" component={BlogArticleTagList} />
				<Route path="article-tags(/:id)/editor" component={BlogArticleTagEditor} />
				<Route path="article-comments" component={BlogArticleCommentList} />
				<Route path="article-comments(/:id)/editor" component={BlogArticleCommentEditor} />
				<IndexRedirect to="articles" />
			</Route>
		)}
		<IndexRedirect to="statistics/general" />
		<Route path="*" component={NotFound} />
	</Route>
);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/routes.js